module.exports = __webpack_public_path__ + "img/banner.b6df1a2a.png";